import React, { useEffect, useState } from 'react'
import SkeletonTable from '../../../components/table/SkeletonTable.jsx'
import columns from '../../../columns/settings/invoiceTemplates.js';
import { GetInvoiceTemplateListApi, DeleteInvoiceTemplateApi } from '../../../api/request/settings/invoiceTemplate.js';
import toast from 'react-hot-toast';
import Add from '../../../assets/Add.jsx';
import ConfirmationModal from '../../../components/modals/ConfirmationModal.jsx';
import Edit from '../../../assets/Edit.jsx';
import Delete from '../../../assets/Delete.jsx';
import moment from 'moment';
import TemplateForm from './components/TemplateForm.jsx';

export default function InvoiceTemplate() {
    const [isTemplateDelete, setIsTemplateDelete] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [templateId, setTemplateId] = useState('');
    const [isLoadingDelete, setIsLoadingDelete] = useState(false);
    const [templates, setTemplates] = useState([]);
    const [mode, setMode] = useState("view");
    const [selectedTemplate, setSelectedTemplate] = useState({});

    const getTemplateList = async () => {
        try {
            setIsLoading(true);
            const { data } = await GetInvoiceTemplateListApi();
            if (data?.status) {
                setTemplates(data?.data?.map((item) => {
                    return {
                        ...item,
                        amount: `$ ${item?.amount}`,
                        status: <div className={`${item?.status == 'active' ? 'text-green-500' : 'text-red-500'} font-semibold uppercase`}>{item?.status}</div>,
                        created_at: item?.created_at ? (moment(item?.created_at).format('LL')) : '',
                        action: <div className='flex items-center gap-3'>
                            <button onClick={() => {
                                setSelectedTemplate(item);
                                setMode("edit");
                            }}><Edit /></button>
                            <button onClick={() => { setIsTemplateDelete(true); setTemplateId(item?.id) }}><Delete /></button>
                        </div>
                    };
                }));
            }
            setIsLoading(false);
        }
        catch (error) {
            setIsLoading(false);
        }
    }

    useEffect(() => {
        getTemplateList();
    }, []);

    const handleDeleteCell = async () => {
        setIsLoadingDelete(true);
        try {
            const { data } = await DeleteInvoiceTemplateApi({ invoice_temp_id: templateId });
            if (data?.status) {
                setIsTemplateDelete(false);
                getTemplateList();
                toast.success(data?.message);
            }
            setIsLoadingDelete(false);
        }
        catch (error) {
            toast.error(error?.response?.data?.message);
            setIsLoadingDelete(false);
        }
    }

    return (
        <div>
            <div className='border-2 rounded-xl'>
                {mode === "view" &&
                    <>
                        <div className='flex justify-between mx-5 mt-5'>
                            <p className=' font-semibold text-2xl'>Invoice Templates</p>
                            <div className='flex gap-3'>
                                <button onClick={() => {
                                    setSelectedTemplate({});
                                    setMode("add");
                                }} className='bg-primary text-white rounded-lg py-2 px-4 flex items-center gap-1'><Add />Add Template</button>
                            </div>
                        </div>
                        <div className='my-6'>
                            <SkeletonTable columns={columns} data={templates} isLoading={isLoading} dateFilterFields = {["created_at"]}/>
                        </div>
                    </>
                }

                {["add", "edit"].includes(mode) && (
                    <TemplateForm
                        mode={mode}
                        setMode={setMode}
                        selectedTemplate={selectedTemplate}
                        setSelectedTemplate={setSelectedTemplate}
                        getTemplateList={getTemplateList}
                    />
                )}
            </div>

            {/* Delete Template */}
            <ConfirmationModal
                isOpen={isTemplateDelete}
                setIsOpen={setIsTemplateDelete}
                message='Are you sure, want to delete this invoice template?'
                onConfirm={() => handleDeleteCell()}
                isLoading={isLoadingDelete}
                loadingLabel='Removing template...'
            />
        </div >
    )
}